import React from 'react';
export const CFIconBluetooth = {
    alias: 'bluetooth',
    defaultTitle: 'Bluetooth',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13 18.25v-4.071l2.467 2.379L13 18.25Zm0-12.49 2.497 1.734L13 9.85V5.76Zm.63 6.246 4.014-3.79a1.133 1.133 0 0 0-.137-1.762L12.833 3.21a1.169 1.169 0 0 0-1.215-.077A1.141 1.141 0 0 0 11 4.145v6.206L7.807 6.374a.999.999 0 1 0-1.56 1.251l3.474 4.327-3.505 4.427a1 1 0 1 0 1.568 1.241L11 13.56v6.293c0 .424.235.811.613 1.011a1.184 1.184 0 0 0 1.214-.07l4.642-3.186a1.135 1.135 0 0 0 .147-1.757l-3.987-3.845Z' }))),
};
